var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"rows":_vm.rows,"prepend-inner-icon":_vm.prependInnerIcon,"outlined":"","hide-details":"auto","value":_vm.value}},'v-textarea',_vm.$attrs,false),_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }